import {
  GlobalEvents,
  SectionElement,
  defineElement,
  globalOn,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/common-header/common-header.ts
var CommonHeader = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.isOpenLanguage = false;
  }
  handleOpenLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.linkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.linkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.open();
  }
  handleOpenChildLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.childLinkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.childLinkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.open();
  }
  handleCloseLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.linkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.linkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.close();
  }
  handleCloseChildLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.childLinkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.childLinkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.close();
  }
  showLanguageModal() {
    return __async(this, null, function* () {
      if (this.isOpenLanguage) {
        void this.closeLanguage();
      } else {
        yield this.openLanguage();
      }
    });
  }
  openLanguage() {
    return __async(this, null, function* () {
      this.languageModal.open();
      this.isOpenLanguage = true;
    });
  }
  closeLanguage() {
    return __async(this, null, function* () {
      this.languageModal.close();
      this.isOpenLanguage = false;
    });
  }
  showModal() {
    var _a;
    (_a = this.searchModal) == null ? void 0 : _a.toggle();
  }
  handleOpenCart() {
    GlobalEvents.emit("cart:open");
  }
  handleOpenMenu() {
    GlobalEvents.emit("menu:open");
  }
  open() {
    return __async(this, null, function* () {
      this.drawer.open();
    });
  }
  close() {
    return __async(this, null, function* () {
      this.drawer.close();
    });
  }
  handleScroll() {
    if (window.scrollY < window.innerHeight / 2) {
      if (!this.hasAttribute("scrolled")) {
        this.setAttribute("scrolled", "");
      }
    } else if (window.scrollY > window.innerHeight / 4) {
      if (this.hasAttribute("scrolled")) {
        this.removeAttribute("scrolled");
      }
    }
  }
  connectedCallback() {
    window == null ? void 0 : window.document.addEventListener("scroll", () => {
      this.handleScroll();
    });
    this.handleScroll();
  }
};
__decorateClass([
  query("[data-menu-drawer]")
], CommonHeader.prototype, "drawer", 2);
__decorateClass([
  query("[search-modal]")
], CommonHeader.prototype, "searchModal", 2);
__decorateClass([
  query("[language-modal]")
], CommonHeader.prototype, "languageModal", 2);
__decorateClass([
  queryAll("[data-link-drawer]")
], CommonHeader.prototype, "linkDrawers", 2);
__decorateClass([
  queryAll("[data-child-link-drawer]")
], CommonHeader.prototype, "childLinkDrawers", 2);
__decorateClass([
  onClick("[data-link-button]")
], CommonHeader.prototype, "handleOpenLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-button]")
], CommonHeader.prototype, "handleOpenChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-link-drawer-close]")
], CommonHeader.prototype, "handleCloseLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-drawer-close]")
], CommonHeader.prototype, "handleCloseChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-language-open]")
], CommonHeader.prototype, "showLanguageModal", 1);
__decorateClass([
  onClick("[data-modal-search]")
], CommonHeader.prototype, "showModal", 1);
__decorateClass([
  onClick("[data-open-cart]")
], CommonHeader.prototype, "handleOpenCart", 1);
__decorateClass([
  onClick("[data-open-menu]")
], CommonHeader.prototype, "handleOpenMenu", 1);
__decorateClass([
  query("[data-additional-text]")
], CommonHeader.prototype, "addText", 2);
__decorateClass([
  query("[data-menu-row]")
], CommonHeader.prototype, "menuRow", 2);
__decorateClass([
  query("[data-menu2-row]")
], CommonHeader.prototype, "menuRow2", 2);
__decorateClass([
  query("[data-row-container]")
], CommonHeader.prototype, "rowContainer", 2);
__decorateClass([
  query("[data-shop-logo]")
], CommonHeader.prototype, "shopLogo", 2);
__decorateClass([
  query("[data-mobile-text]")
], CommonHeader.prototype, "addTextMobile", 2);
__decorateClass([
  query("[data-menu-row-mega]")
], CommonHeader.prototype, "menuRowMega", 2);
__decorateClass([
  globalOn("menu:open")
], CommonHeader.prototype, "open", 1);
__decorateClass([
  globalOn("menu:close"),
  onClick("[data-menu-close]")
], CommonHeader.prototype, "close", 1);
CommonHeader = __decorateClass([
  defineElement("common-header")
], CommonHeader);
export {
  CommonHeader
};
